import { render, staticRenderFns } from "./assistantcommitteequalified.vue?vue&type=template&id=490d1b88&scoped=true&"
import script from "./assistantcommitteequalified.vue?vue&type=script&lang=js&"
export * from "./assistantcommitteequalified.vue?vue&type=script&lang=js&"
import style0 from "./assistantcommitteequalified.vue?vue&type=style&index=0&id=490d1b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d1b88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
